import { render } from "./channelDialog.vue?vue&type=template&id=d47e9dd0&scoped=true"
import script from "./channelDialog.vue?vue&type=script&lang=js"
export * from "./channelDialog.vue?vue&type=script&lang=js"

import "./channelDialog.vue?vue&type=style&index=0&id=d47e9dd0&scoped=true&lang=css"

import exportComponent from "F:\\yiban\\WebProject\\yimeng-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d47e9dd0"]])

export default __exports__